module.exports = __webpack_public_path__ + "img/s2v2.3c0b3a23.jpeg";